import { AlertTriangle, Home, RotateCcw } from 'lucide-react'
import { Button, Result } from 'antd'
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom'
import { useTranslations } from '@/lib/i18n/hooks'

export default function RouteErrorPage() {
  const error = useRouteError()
  const navigate = useNavigate()
  const t = useTranslations('errors')
  const isNotFound = isRouteErrorResponse(error) && error.status === 404

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--color-bg-page)] px-4">
      <Result
        icon={<AlertTriangle className="mx-auto h-16 w-16 text-[var(--color-warning)]" />}
        status={isNotFound ? '404' : 'error'}
        title={isNotFound ? '404' : t('unexpectedTitle')}
        subTitle={isNotFound ? t('notFound') : t('unexpectedDescription')}
        extra={
          <div className="flex justify-center gap-3">
            <Button icon={<RotateCcw className="h-4 w-4" />} onClick={() => window.location.reload()}>
              {t('retry')}
            </Button>
            <Button type="primary" icon={<Home className="h-4 w-4" />} onClick={() => navigate('/activities')}>
              {t('goHome')}
            </Button>
          </div>
        }
      />
    </div>
  )
}
